import classNames from 'classnames'
import React from 'react'

import Header from './Header'

import Alert from 'admin/components/common/Alert'
import WindowTitle from 'admin/components/common/WindowTitle'
import Footer from 'components/common/Footer'
import Modal from 'components/ui/Modal'
import Toast from 'components/ui/Toast'
import { Tooltip } from 'components/ui/Tooltip'

const normalizeRedirectUrl = (url: string): string => {
  let normalized = url

  if (normalized.includes('/organisation/admin/')) {
    normalized = `${normalized.split('/organisation/admin/')[0]}/organisation`
  }

  if (normalized.includes('/orgkonto/orgadmin/')) {
    normalized = `${normalized.split('/orgkonto/orgadmin/')[0]}/orgkonto`
  }

  if (normalized.includes('/fakturamottagare/')) {
    normalized = `${normalized.split('/fakturamottagare/')[0]}/fakturamottagare`
  }

  if (normalized.includes('/fakturamottagaradministrator')) {
    normalized = `${normalized.split('/fakturamottagaradministrator')[0]}/fakturamottagare`
  }

  return normalized
}

const PageFrame: React.FC<PageFrameProps> = props => {
  const { windowTitle, header, footer, contentContainerClassName, childContainerClassName, children } = props
  
  // Need to inform users of the name change to fakturatjanst
  const includesOldDomain = window.location.hostname.includes('inkopstjanst')
  
  const normalizedUrl = normalizeRedirectUrl(window.location.href)
  const newURL = normalizedUrl.replace(/inkopstjanst/g, 'fakturatjanst')

  // Excluded path
  const isSelectOrgAccountPage = window.location.pathname === '/admin/valj_orgkonto'
  const showNewDomainBanner = includesOldDomain && !isSelectOrgAccountPage
  
  return <div className="l-wrapper">
    <div id="main-container" className="l-main-container l-rows">
      <WindowTitle>{windowTitle}</WindowTitle>
      {header && <Header className="l-flex l-flex--fixed" newURL={newURL} includesOldDomain={showNewDomainBanner} />}
      <div className={classNames('Content', 'l-flex', includesOldDomain && 'l-margin--t', contentContainerClassName)}>
        <div className={classNames('l-container', 'l-position__relative', 'l-min-height--10', childContainerClassName)}>
          {children}
        </div>
      </div>
      {footer && <Footer/>}
    </div>
    <Toast alertComponent={Alert} />
    <Tooltip />
    <Modal />
  </div>
}

PageFrame.defaultProps = {
  header: true,
  footer: true,
}

type PageFrameProps = {
  windowTitle?: string,
  header?: boolean,
  footer?: boolean,
  contentContainerClassName?: string,
  childContainerClassName?: string,
  children?: React.ReactNode,
}

export default PageFrame
